import {
    Stack,
    Button,
    RadioGroup,
    FormControlLabel,
    Typography,
    Box,
} from "@mui/material";
import { useEffect } from "react";

import { useCheckout } from "../CheckoutContext";
import SquareRadio from "./SquareRadio";

export default function PaymentStep() {
    const {
        updateSection,
        prevStep,
        checkoutData,
        nextStep,
        setActiveStep,
        isWholesale,
    } = useCheckout();

    const selected = checkoutData.payment.method;
    const isValid = Boolean(selected);

    useEffect(() => {
        if (isWholesale && selected === "credit_link") {
            updateSection("payment", { method: "" });
        }
    }, [isWholesale, selected]);

    const options = [
        { value: "pix", label: "PIX (aprovação imediata)" },
        { value: "credit", label: "Cartão de crédito" },
    ];

    const handlePaymentChange = (method) => {
        updateSection("payment", { method });
    };

    return (
        <Stack spacing={3}>
            <Typography variant="h6">Forma de pagamento</Typography>

            <RadioGroup
                value={selected}
                onChange={(e) => handlePaymentChange(e.target.value)}
            >
                {options.map((opt) => (
                    <Box
                        key={opt.value}
                        sx={{
                            border: "1px solid #e5e7eb",
                            borderRadius: 2,
                            px: 2,
                            py: 1.5,
                            mb: 1,
                            display: "flex",
                            alignItems: "center",
                            transition: "border 0.15s ease",
                            "&:has(input:checked)": {
                                borderColor: "#1e293b",
                            },
                        }}
                    >
                        <FormControlLabel
                            value={opt.value}
                            control={<SquareRadio />}
                            label={opt.label}
                            sx={{ width: "100%" }}
                        />
                    </Box>
                ))}
            </RadioGroup>

            <Stack direction="row" spacing={2}>
                <Button variant="outlined" onClick={prevStep} fullWidth>
                    Voltar
                </Button>

                <Button
                    variant="contained"
                    disabled={!isValid}
                    onClick={nextStep}
                    fullWidth
                >
                    Revisar pedido
                </Button>
            </Stack>
        </Stack>
    );
}
